module.exports = __webpack_public_path__ + "application/templates/unmark-email/unmark-email.template.html";